import { fragmentLinkQuery } from './link'
import { fragmentMediaQuery, fragmentMediaWithCoverQuery } from './media'
import { fragmentMaskShapeQuery } from './mask-shape'

export const fragmentBlockLinksQuery =
`
  ... on BlockLinks {
    label
    id
    rightAlign
    anchor
    includeInPageNavigation
    blockName
    blockType
    links {
      id
      link ${fragmentLinkQuery}
    }
  }
`

export const fragmentBlockMediaArrayQuery =
`
  ... on BlockMediaArray {
    label
    id
    rightAlign
    anchor
    includeInPageNavigation
    blockName
    blockType
    media ${fragmentMediaWithCoverQuery}
  }
`

export const fragmentBlockHeadingQuery =
`
  ... on BlockHeading {
    heading
    subHeading
    rightAlign
    anchor
    id
    blockName
    blockType
  }
`

export const fragmentBlockRichTextQuery =
`
  ... on BlockRichText {
    id
    blockName
    rightAlign
    anchor
    blockType
    truncate
    wordLimit
    typeSize
    richText
  }
`

export const fragmentBlockImagesQuery =
`
  ... on BlockImages {
    id
    blockName
    rightAlign
    anchor
    hideCaptions
    blockType
    useMask
    alignCaptionToMask
    images ${fragmentMediaQuery}
    maskShape ${fragmentMaskShapeQuery}
  }
`

export const fragmentBlockSummaryQuery =
`
  ... on BlockSummary {
    label
    description
    rightAlign
    anchor
    includeInPageNavigation
    summaryItems {
      label
      richText
      id
    }
    id
    blockName
    blockType
    viewOption
    multipleOpenAtOnce
  }
`

export const fragmentBlockItemQuery =
`
  ... on BlockItem {
    label
    richText
    rightAlign
    anchor
    includeInPageNavigation
    truncate
    link ${fragmentLinkQuery}
    useMask
    image ${fragmentMediaQuery}
    maskedMedia {
      maskShape ${fragmentMaskShapeQuery}
      file ${fragmentMediaQuery}
    }
    id
    blockName
    blockType
  }
`

export const fragmentsBlockDownloadQuery = `
  ... on BlockDownloads {
    label
    id
    rightAlign
    anchor
    includeInPageNavigation
    files ${fragmentMediaWithCoverQuery}
    layout
    blockName
    blockType
}
`

export const fragmentBlockPersonListQuery = `
  ... on BlockPersonList {
    label
    intro
    rightAlign
    anchor
    includeInPageNavigation
    items {
      id
      internal
      person {
        id
        title
        slug
      }
      name
      role
    }
    columnOrder
    id
    blockName
    blockType
  }
`

export const fragmentBlockEventsQuery = `
  ... on BlockEvents {
    id
    blockName
    rightAlign
    anchor
    blockType
    richText
    programmeTypes {
      id
      title
      slug
    }
  }
`

export const fragmentBlocksQuery =
`{
  ${fragmentBlockHeadingQuery}
  ${fragmentBlockRichTextQuery}
  ${fragmentBlockImagesQuery}
  ${fragmentBlockSummaryQuery}
  ${fragmentBlockItemQuery}
  ${fragmentsBlockDownloadQuery}
  ${fragmentBlockPersonListQuery}
  ${fragmentBlockLinksQuery}
  ${fragmentBlockMediaArrayQuery}
  ${fragmentBlockEventsQuery}
}`
